import decode from "jwt-decode";

const ID_TOKEN_KEY = "id_token";
const ACCESS_TOKEN_KEY = "access_token";

var logout = function(router) {
  clearIdToken();
  clearAccessToken();
  router.push({ path: "/" });
};

var setAccessToken = function() {
  let accessToken = getParameterByName("access_token");
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
};
var setIdToken = function(idToken) {
  if (!idToken) {
    idToken = getParameterByName("id_token");
  }
  localStorage.setItem(ID_TOKEN_KEY, idToken);
};
var getIdToken = function() {
  return localStorage.getItem(ID_TOKEN_KEY);
};
var getAccessToken = function() {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
};
var isLoggedIn = function() {
  const accessToken = getIdToken();

  return !!accessToken && !isTokenExpired(accessToken);
};

export default {
  logout: logout,
  setAccessToken: setAccessToken,
  setIdToken: setIdToken,
  getIdToken: getIdToken,
  getAccessToken: getAccessToken,
  isLoggedIn: isLoggedIn
};

// Helper function that will allow us to extract the access_token and id_token
function getParameterByName(name) {
  var uriHash = window.location.hash;
  console.log("uri", uriHash);
  let match = RegExp("[#&]" + name + "=([^&]*)").exec(uriHash);
  return match && decodeURIComponent(match[1].replace(/\+/g, " "));
}

function clearIdToken() {
  localStorage.removeItem(ID_TOKEN_KEY);
}

function clearAccessToken() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
}

function getTokenExpirationDate(encodedToken) {
  if (encodedToken === "undefined") {
    return null;
  }
  const token = decode(encodedToken);
  if (!token.exp) {
    return null;
  }

  const date = new Date(0);
  date.setUTCSeconds(token.exp);

  return date;
}

function isTokenExpired(token) {
  const expirationDate = getTokenExpirationDate(token);
  var expired = expirationDate < new Date();
  if (expired) {
    clearIdToken();
    clearAccessToken();
  }
  return expirationDate < new Date();
}
